import React, { useEffect, useRef, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import { Header } from '../../components/Header/Header';
import { Footer } from '../../components/Footer/Footer';
import { db } from '../../../service/firebase';
import { useAuth } from '../../../context/AuthContext';
import { joinTurmaViaLink, getTurmaMembershipForUser } from '../../../service/turmaService';
import './TurmaInviteLink.css';

const TurmaInviteLink = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [turma, setTurma] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [senha, setSenha] = useState('');
  const [isAdminDaTurma, setIsAdminDaTurma] = useState(false);
  const redirectRef = useRef(false);
  const turmaStatus = typeof turma?.status === 'number' ? turma.status : 1;
  const turmaAtiva = turmaStatus === 1;
  const precisaSenha = turma?.protegida && turmaAtiva && !isAdminDaTurma;

  useEffect(() => {
    const fetchTurma = async () => {
      try {
        const turmaDoc = await getDoc(doc(db, 'turmas', id));
        if (!turmaDoc.exists()) {
          setError('Turma não encontrada.');
          return;
        }
        setTurma({ id, ...turmaDoc.data() });
      } catch (err) {
        console.error('Erro ao carregar convite', err);
        setError('Não foi possível carregar as informações desta turma.');
      } finally {
        setLoading(false);
      }
    };
    fetchTurma();
  }, [id]);

  useEffect(() => {
    const verificarAdmin = async () => {
      if (!user?.uid || !id || redirectRef.current) return;
      try {
        const membership = await getTurmaMembershipForUser({ turmaId: id, userId: user.uid });
        if (membership?.admin) {
          setIsAdminDaTurma(true);
          redirectRef.current = true;
          navigate(`/turmas/${id}`, { replace: true });
        }
      } catch (err) {
        console.error('Erro ao verificar admin da turma', err);
      }
    };
    verificarAdmin();
  }, [user, id, navigate]);

  const handleJoin = async () => {
    if (!user) return;
    if (isAdminDaTurma) {
      navigate(`/turmas/${id}`);
      return;
    }
    setError('');
    setMessage('');
    if (!turmaAtiva) {
      setError('Esta turma não está ativa para novos membros.');
      return;
    }
    if (precisaSenha && !senha) {
      setError('Digite a senha da turma para entrar.');
      return;
    }
    try {
      await joinTurmaViaLink({ turmaId: id, userId: user.uid, senha });
      setMessage('Você entrou na turma! Redirecionando...');
      setTimeout(() => navigate('/turmas'), 1500);
    } catch (err) {
      console.error('Erro ao ingressar na turma', err);
      if (err.message?.includes('já faz parte')) {
        setMessage('Você já faz parte desta turma!');
        setTimeout(() => navigate('/turmas'), 1500);
      } else {
        setError(err.message || 'Não foi possível ingressar na turma.');
      }
    }
  };

  return (
    <>
      <Header />
      <div className="body">
        <div className="center">
          <div className="body-content card convite-link-card">
            {loading ? (
              <span>Carregando convite...</span>
            ) : error ? (
              <p className="turmas-error" role="alert">
                {error}
              </p>
            ) : (
              <>
                <div className="topo-page">
                  <strong># Convite para {turma.nome}</strong>
                </div>
                <p className="turmas-description">
                  Local: <strong>{turma.local}</strong>
                </p>
                <p className="turmas-description">
                  Dias: <strong>{turma.dias_semana?.join(', ') || 'A definir'}</strong>
                </p>
                {!turmaAtiva && (
                  <p className="turmas-error">
                    Esta turma está {turmaStatus === 2 ? "encerrada" : "inativa"} e não aceita novos membros.
                  </p>
                )}
                {precisaSenha && (
                  <div className="turma-invite-password">
                    <p>Esta turma é protegida por senha. Informe-a para participar.</p>
                    <input
                      type="password"
                      placeholder="Senha da turma"
                      value={senha}
                      onChange={(event) => setSenha(event.target.value)}
                    />
                  </div>
                )}
                {message && <p className="turmas-success">{message}</p>}
                <button
                  type="button"
                  className="btn-default"
                  onClick={handleJoin}
                  disabled={!turmaAtiva}
                >
                  Entrar na turma
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TurmaInviteLink;
